module.exports = __webpack_public_path__ + "media/components/signup/static/check-d263ad5278285baa8577d2d7ebdf0a2b.svg";